import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';

export function useBannerActions() {
	const { actions } = useStartAPetitionPageState();
	const track = useTracking();

	const edit = useCallback(
		(placement: 'top' | 'bottom') => {
			void track('sap_edit_click', { placement, context: 'preview' });
			actions.send({ type: 'submit', target: 'edit' });
		},
		[actions, track],
	);

	const clear = useCallback(
		(placement: 'top' | 'bottom') => {
			const emptyDraft = { ask: null, description: null, image: null };
			void track('sap_clear_draft_click', { placement, context: 'preview' });
			actions.send({
				type: 'submit',
				target: 'edit',
				draft: { petitionDraft: emptyDraft, metadata: { draftMode: 'user_draft' } },
			});
		},
		[actions, track],
	);

	return { actions: { edit, clear } };
}
